import { render, staticRenderFns } from "./goods-table.vue?vue&type=template&id=592ec531&"
import script from "./goods-table.vue?vue&type=script&lang=js&"
export * from "./goods-table.vue?vue&type=script&lang=js&"
import style0 from "./goods-table.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports